import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { useQueryPromotionData } from '@/hooks/cart.hook';
import { useParams } from 'next/navigation';
import { useState, useEffect } from 'react';
import { Button } from '@/shared/components';
import { useAppStore } from '@/store/app-store';
import { useCartStore } from '@/app/cart/cart-store';

interface IProps {
  childCatalogs: any;
}
const PromotionData = (props) => {
  const { t, lang } = useLang(NAMESPACE.pdp);
  const { item } = props;
  const [showDesc, setShowDesc] = useState(false);
  return (
    <div key={item.id} className="grid p-4 border-x-0 border-t-0 border-b-1 border-gray-400 border-solid">
      <div className="flex">
        <div className="bg-[#daeeda] border inline-block px-2.5 py-0 rounded-[10px] border-solid border-[#daeeda] text-[green]">
          {t('promotion')}
        </div>
        <div className="px-5 py-0 flex">
          {t('promo.code')}:&nbsp;<p className="font-bold">{item.promoCode}</p>&nbsp;-&nbsp;{item.promoName}
        </div>
        {item.promoDesc && !showDesc && (
          <div onClick={() => setShowDesc(true)}>
            <i className="icon-16-chevron-up-bold" />
          </div>
        )}
        {item.promoDesc && showDesc && (
          <div onClick={() => setShowDesc(false)}>
            <i className="icon-16-chevron-down-bold" />
          </div>
        )}
      </div>
      {item.promoDesc && showDesc && <div className="pt-2" dangerouslySetInnerHTML={{ __html: item.promoDesc }}></div>}
    </div>
  );
};
export const Promotion = (props: IProps) => {
  const { childCatalogs } = props;
  const { t, lang } = useLang(NAMESPACE.pdp);
  const cartStore = useCartStore();
  const defaultCount = 3;
  const [count, setCount] = useState(defaultCount);
  const [promotionData, setPromotionData] = useState(null);
  const [showViewMore, setShowViewMore] = useState(false);
  const [showViewLess, setShowViewLess] = useState(false);
  const { shipToList, isAnonymous, billToInfo } = useAppStore();
  const { mutateAsync, isLoading } = useQueryPromotionData();
  const getPromoData = async () => {
    const selectedProductsArray = childCatalogs.map((product) => ({
      catalogNumber: product.childCatalogNumber,
      webCatalogNumber: product.webCatalogNumber,
      quantity: 1,
    }));
    const promoData = {
      pageType: '2',
      itemList: selectedProductsArray,
    };
    if (!isAnonymous) {
      const billToId = billToInfo?.accountNumber;
      let shipTo = null;
      let addressKey = null;
      if (shipToList && shipToList.length > 0) {
        let defaultAddress = shipToList.find((ship) => ship.isDefault);
        if (!defaultAddress) {
          defaultAddress = shipToList[0];
        }
        shipTo = defaultAddress.accountNumber;
        addressKey = defaultAddress.addressKey;
      }
      promoData['billToId'] = billToId;
      promoData['shipToId'] = shipTo;
      promoData['shipToAddressKey'] = addressKey;
    }
    const promo = await mutateAsync(promoData);
    if (promo) {
      if (promo.data && promo.data.length > 0) {
        setPromotionData(promo.data);
      }
    }
  };
  useEffect(() => {
    if (!childCatalogs) return;
    if (isLoading) return;
    if (!isAnonymous && (!billToInfo || Object.keys(billToInfo).length === 0)) return;
    getPromoData();
  }, [childCatalogs, billToInfo]);
  useEffect(() => {
    if (!promotionData) return;
    if (promotionData?.length > defaultCount) {
      setShowViewMore(true);
      setCount(defaultCount);
    } else {
      setShowViewMore(false);
      setCount(promotionData.length);
    }
  }, [promotionData]);
  return (
    <div className="flex md:flex-col sm:flex-col">
      <div className="w-[200px]"></div>
      <div className="ml-[70px] sm:ml-0 md:ml-0 sm:mt-4 md:mt-4 flex-grow">
        {promotionData &&
          promotionData.slice(0, count).map((item, index) => {
            return <PromotionData key={index} item={item} />;
          })}
        {showViewMore && (
          <div className="flex justify-center items-center pt-2">
            <Button
              type="link"
              onClick={() => {
                setCount(promotionData.length);
                setShowViewMore(false);
                setShowViewLess(true);
              }}
            >
              {t('view.more')}
            </Button>
          </div>
        )}
        {showViewLess && (
          <div className="flex justify-center items-center pt-2">
            <Button
              type="link"
              onClick={() => {
                setCount(defaultCount);
                setShowViewMore(true);
                setShowViewLess(false);
              }}
            >
              {t('view.less')}
            </Button>
          </div>
        )}
      </div>
      <div className="min-w-[260px] ml-6 sm:ml-0 md:ml-0 flex flex-col justify-end"></div>
    </div>
  );
};
